import { Link } from "react-router-dom";

type InternalLinkItem = {
  href: string;
  label: string;
  description?: string;
};

type InternalLinkSectionProps = {
  title: string;
  description?: string;
  links: InternalLinkItem[];
  compact?: boolean;
  className?: string;
};

export const InternalLinkSection = ({
  title,
  description,
  links,
  compact = false,
  className = "",
}: InternalLinkSectionProps) => {
  if (links.length === 0) {
    return null;
  }

  return (
    <section
      className={`rounded-2xl border border-border bg-card/60 ${compact ? "p-6" : "p-8 md:p-10"} ${className}`.trim()}
    >
      <div className="mb-5 space-y-2">
        <h2 className={`${compact ? "text-xl" : "text-2xl"} font-semibold text-foreground`}>
          {title}
        </h2>
        {description ? (
          <p className="max-w-3xl text-sm text-text-secondary">{description}</p>
        ) : null}
      </div>

      <div
        className={
          compact
            ? "grid gap-3 sm:grid-cols-2 lg:grid-cols-3"
            : "grid gap-4 sm:grid-cols-2 lg:grid-cols-3"
        }
      >
        {links.map((link) => (
          <Link
            key={link.href}
            to={link.href}
            className="rounded-xl border border-border bg-background/70 p-4 transition-colors hover:border-foreground/30 hover:bg-background"
          >
            <p className="font-medium text-foreground">{link.label}</p>
            {link.description ? (
              <p className="mt-1 text-sm text-text-secondary">
                {link.description}
              </p>
            ) : null}
          </Link>
        ))}
      </div>
    </section>
  );
};
